import { HeartHandshake, TreeDeciduous, Search, Sparkles, Sprout, Sunrise } from "lucide-react";
import { Reveal, SectionLabel } from "@/components/Reveal";

const PARCOURS = [
  { icon: HeartHandshake, title: "Accueillir", text: "Vous êtes écouté(e), compris(e) et en confiance. Nous identifions ensemble ce que vous souhaitez changer en priorité." },
  { icon: TreeDeciduous, title: "Comprendre", text: "Mieux comprendre les facteurs qui influencent votre situation — personnels, familiaux, environnementaux, habitudes de vie." },
  { icon: Search, title: "Explorer", text: "Prendre conscience des causes sous-jacentes et des schémas qui maintiennent les difficultés en place." },
  { icon: Sparkles, title: "Transformer", text: "Adopter de nouvelles pensées et de nouveaux comportements qui soutiennent votre rétablissement." },
  { icon: Sprout, title: "Intégrer", text: "Les changements s'intègrent à votre quotidien et deviennent progressivement naturels." },
  { icon: Sunrise, title: "Consolider", text: "Vous repartez plus autonome, confiant(e) et outillé(e) pour maintenir vos progrès et prévenir les rechutes." },
];

export default function Parcours() {
  return (
    <section data-testid="parcours-section" className="mx-auto max-w-[1500px] px-6 py-24 md:px-12 md:py-32 lg:px-24">
      <Reveal>
        <SectionLabel>Notre modèle d'intervention</SectionLabel>
        <p className="mt-8 font-serif text-xl italic leading-snug text-gold md:text-2xl">
          Comment passe-t-on du point où l'on est… à la vie que l'on désire ?
        </p>
        <h2 className="mt-4 max-w-3xl font-serif text-4xl font-light leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
          Le parcours <em className="text-sage-dark">Émergence</em>
        </h2>
        <p className="mt-8 max-w-2xl text-lg leading-relaxed text-deep/70">
          Un parcours clair en six étapes pour vous guider du premier éclairage jusqu'à l'autonomie et au changement durable — à votre rythme, dans le respect de votre réalité.
        </p>
      </Reveal>

      <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {PARCOURS.map((p, i) => (
          <Reveal key={p.title} delay={(i % 3) * 0.08}>
            <div data-testid={`parcours-step-${i + 1}`} className="group relative flex h-full flex-col rounded-3xl border border-deep/10 bg-white/50 p-8 transition-all duration-500 hover:-translate-y-1 hover:border-gold/40">
              <div className="flex items-center justify-between">
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-sage/15 transition-colors duration-500 group-hover:bg-gold/15">
                  <p.icon className="h-5 w-5 text-sage-dark transition-colors duration-500 group-hover:text-gold" />
                </span>
                <span className="font-serif text-4xl font-light italic text-gold/60">{i + 1}</span>
              </div>
              <h3 className="mt-6 font-serif text-2xl font-light uppercase tracking-[0.06em] text-deep">{p.title}</h3>
              <p className="mt-3 flex-1 leading-relaxed text-deep/60">{p.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
